"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./timeline-dot.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TimelineDot = function TimelineDot() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "timeline-item__dot"
  });
};

var _default = TimelineDot;
exports["default"] = _default;